import React, { useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { injectReducer } from 'store'
import reducer from './store'
import { useDispatch, useSelector } from 'react-redux'
import { getHistoryData, setHistoryTableData } from './store/dataSlice'
import { numberFormat } from 'components/helper'
import dayjs from 'dayjs'
import { Table } from 'components/Ui'
injectReducer('verifiedInvoices', reducer)

export default function InvoiceHistory() {
    const dispatch = useDispatch()
    const { id } = useParams()
    const { historyData, historyTableData, loading } = useSelector(
        (state) => state.verifiedInvoices.data,
    )

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        historyTableData.sort,
        historyTableData.query,
        historyTableData.pageIndex,
        historyTableData.pageSize,
        historyTableData.selectedTab,
        historyTableData.service,
    ])

    const fetchData = () =>
        dispatch(getHistoryData({ ...historyTableData, invoiceNumber: id }))

    const columns = useMemo(
        () => [
            {
                field: 'invoice_num',
                header: 'Invoice Number',
                className: 'min-w-[150px]',
            },
            {
                field: 'invoiced_total',
                header: 'Invoice Total',
                className: 'min-w-[150px]',
                renderCell: (row) => numberFormat(row?.invoiced_total, 'AUD'),
            },
            {
                field: 'calculated_total',
                header: 'Calculated Total',
                className: 'min-w-[150px]',
                renderCell: (row) => numberFormat(row?.calculated_total, 'AUD'),
            },
            {
                field: 'total_difference',
                header: 'Total Difference',
                className: 'min-w-[150px]',
                renderCell: (row) => numberFormat(row?.total_difference, 'AUD'),
            },
            {
                field: 'uploaded_at',
                header: 'Uploaded At',
                className: 'min-w-[150px]',
                renderCell: (row) =>
                    row?.invoice_id?.uploaded_at
                        ? dayjs(row?.invoice_id?.uploaded_at).format(
                              'DD-MMM-YYYY  hh:mm A',
                          )
                        : '-',
            },
        ],
        // eslint-disable-next-line
        [
            historyTableData.sort,
            historyTableData.query,
            historyTableData.pageIndex,
            historyTableData.pageSize,
            historyTableData.selectedTab,
            historyTableData.service,
        ],
    )

    return (
        <>
            <div className="flex flex-col gap-1 mb-5 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">
                    Invoice history
                </h2>
            </div>
            <Table
                loading={loading}
                filter={false}
                datas={historyData}
                columns={columns}
                pagingData={historyTableData}
                onChange={(e) => dispatch(setHistoryTableData(e))}
            />
        </>
    )
}
